export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换",
    "reset": "重置"
  },
  "footer": {
    "privacy": "隐私政策",
    "terms": "使用条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。",
    "trust": {
      "local": "🔒 纯本地处理，数据零上传",
      "free": "✅ 免费使用，无需注册",
      "formats": "📐 支持PNG/SVG/PDF高清导出"
    },
    "relatedTools": "相关工具"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "qr": {
    "title": "二维码生成器",
    "description": "免费生成URL、文本、WiFi、vCard名片、邮件、电话、短信等多种类型二维码。零注册、零广告、纯前端处理保护隐私。",
    "types": {
      "url": "网址",
      "text": "文本",
      "wifi": "WiFi",
      "email": "邮件",
      "phone": "电话",
      "sms": "短信",
      "vcard": "名片"
    },
    "input": {
      "urlLabel": "网站链接",
      "urlPlaceholder": "https://example.com",
      "textLabel": "文本内容",
      "textPlaceholder": "在此输入文本内容...",
      "wifi": {
        "ssidLabel": "网络名称 (SSID)",
        "ssidPlaceholder": "MyWiFi",
        "passwordLabel": "密码",
        "passwordPlaceholder": "WiFi密码",
        "encryptionLabel": "加密方式",
        "hiddenLabel": "隐藏网络"
      },
      "email": {
        "emailLabel": "邮箱地址",
        "emailPlaceholder": "someone@example.com",
        "subjectLabel": "主题",
        "subjectPlaceholder": "邮件主题",
        "bodyLabel": "正文",
        "bodyPlaceholder": "邮件正文内容..."
      },
      "phoneLabel": "电话号码",
      "phonePlaceholder": "+86 138 0000 0000",
      "sms": {
        "phoneLabel": "电话号码",
        "phonePlaceholder": "+86 138 0000 0000",
        "messageLabel": "短信内容",
        "messagePlaceholder": "短信内容..."
      },
      "vcard": {
        "nameLabel": "姓名",
        "namePlaceholder": "张三",
        "phoneLabel": "电话",
        "phonePlaceholder": "+86 138 0000 0000",
        "emailLabel": "邮箱",
        "emailPlaceholder": "zhangsan@example.com",
        "orgLabel": "公司",
        "orgPlaceholder": "某某科技有限公司",
        "titleLabel": "职位",
        "titlePlaceholder": "软件工程师",
        "urlLabel": "网站",
        "urlPlaceholder": "https://example.com",
        "addressLabel": "地址",
        "addressPlaceholder": "北京市朝阳区某某街道123号"
      }
    },
    "design": {
      "title": "设计与选项",
      "foregroundColor": "前景色",
      "backgroundColor": "背景色",
      "presets": "配色方案",
      "logo": {
        "title": "Logo叠加",
        "upload": "上传Logo (PNG/JPG/SVG)",
        "dragDrop": "拖拽上传或点击选择文件",
        "whiteBorder": "添加白色边框",
        "borderSize": "边框大小",
        "remove": "移除"
      },
      "errorCorrection": "纠错级别",
      "levels": {
        "L": "L (7%)",
        "M": "M (15%)",
        "Q": "Q (25%)",
        "H": "H (30%)"
      },
      "levelHint": "更高级别支持Logo叠加，并在打印模糊或污损时提高扫码成功率。"
    },
    "preview": {
      "title": "实时预览",
      "status": "实时预览 · 可扫描测试",
      "empty": "输入内容即可生成二维码",
      "generating": "生成中...",
      "errorCorrection": "纠错: {level}"
    },
    "download": {
      "title": "下载",
      "png512": "PNG (512px)",
      "png1024": "PNG (1024px) — 推荐",
      "png2048": "PNG (2048px)",
      "svg": "SVG 矢量",
      "pdf": "PDF (A4 印刷)",
      "filename": "qr-cikastudio-{type}-{date}"
    },
    "actions": {
      "copyData": "复制数据",
      "resetConfig": "重置配置"
    },
    "errors": {
      "urlInvalid": "请输入以 http:// 或 https:// 开头的有效网址",
      "required": "此项为必填",
      "contentTooLong": "内容过长，超出二维码容量。请尝试缩短网址或使用更短的文本。"
    },
    "security": {
      "note": "🔒 所有处理均在您的浏览器本地完成，数据不会上传至任何服务器。"
    },
    "faq": {
      "title": "常见问题",
      "q1": "生成的二维码是否可以免费商用？",
      "a1": "是的，所有静态二维码完全免费生成，可自由用于商业用途，无水印。",
      "q2": "二维码数据是否会上传到服务器？",
      "a2": "不会。本工具纯前端实现，所有生成逻辑在您的浏览器本地完成，数据零上传。",
      "q3": "支持哪些二维码内容类型？",
      "a3": "支持网址链接、纯文本、WiFi网络、vCard电子名片、邮件地址、电话号码和短信。",
      "q4": "可以自定义二维码样式吗？",
      "a4": "可以。支持自定义前景色、背景色、Logo叠加、纠错级别调整，以及预设配色方案。",
      "q5": "支持导出哪些格式？",
      "a5": "支持PNG（512px/1024px/2048px）、SVG矢量格式、以及PDF印刷格式，全部免费下载。"
    },
    "scenarios": {
      "title": "使用场景",
      "url": {
        "title": "网站链接",
        "desc": "分享您的网站、博客或社交媒体，一扫即达。"
      },
      "wifi": {
        "title": "WiFi共享",
        "desc": "让访客无需输入密码即可连接您的网络。"
      },
      "vcard": {
        "title": "数字名片",
        "desc": "专业分享联系方式，一扫保存到通讯录。"
      },
      "email": {
        "title": "邮件预填",
        "desc": "预填主题和正文，方便客户联系或提交表单。"
      },
      "phone": {
        "title": "快速拨号",
        "desc": "客服热线或紧急号码，扫码一键拨打。"
      },
      "text": {
        "title": "纯文本",
        "desc": "编码任何文本消息、备注或优惠券码。"
      }
    }
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有二维码生成均在您的浏览器本地完成。您的数据绝不会被上传到任何服务器。"
    },
    "guide": {
      "title": "如何使用二维码生成器",
      "description": "为 URL、文本、WiFi、名片等创建可扫描的二维码。",
      "steps": [
        {
          "title": "选择二维码类型",
          "description": "从 URL、文本、WiFi、电子邮件、电话、短信或 vCard 联系人格式中进行选择。每种类型都会自动生成正确的数据格式。"
        },
        {
          "title": "输入数据",
          "description": "填写所选二维码类型的字段。对于 WiFi，请输入 SSID、密码和加密类型。对于 URL，只需粘贴链接即可。"
        },
        {
          "title": "下载二维码",
          "description": "自定义颜色和尺寸，然后将二维码下载为 PNG 或 SVG。所有二维码均经过纠错处理，任何现代智能手机均可扫描。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "支持 7 种以上二维码类型：URL、文本、WiFi、电子邮件、电话、短信、vCard",
        "可自定义前景和背景颜色",
        "下载为高分辨率 PNG 或可缩放的 SVG",
        "输入时实时预览",
        "具备纠错能力，即使部分损坏也能可靠扫描",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的二维码数据会被发送到服务器吗？",
          "answer": "不会。所有二维码生成均在您的浏览器内完成。您的 URL、WiFi 密码和联系人信息绝不会离开您的设备。"
        },
        {
          "question": "二维码可以在任何手机上使用吗？",
          "answer": "可以。生成器生成标准二维码，任何现代智能手机相机应用以及 iOS 和 Android 上的专用二维码扫描应用均可扫描。"
        },
        {
          "question": "可以在中心放置自定义 logo 吗？",
          "answer": "目前该工具专注于生成简洁、可靠的二维码。如需嵌入 logo，请导出 SVG 并使用设计工具（如我们的图片水印工具）叠加您的 logo。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "UUID 生成器",
          "url": "/generator/uuid-generator",
          "description": "为 API 和数据库生成通用唯一标识符。"
        },
        {
          "name": "随机数生成器",
          "url": "/generator/random-number-generator",
          "description": "生成随机整数、小数、十六进制和二进制数字。"
        },
        {
          "name": "Base64 转换器",
          "url": "/converter/base64",
          "description": "快速安全地编码和解码 Base64 字符串。"
        }
      ]
    }
  }
};
